export default __webpack_public_path__ + "static/media/shopping-cart.66e506fd.svg";